export enum EnumUploadCargaStatus {
    Aguardando = 0,
    Analisando = 10,
    AguardandoProcessamento = 20,
    Processando = 30,
    Processado = 40,
    Cancelado = 50,
    Erro = 60
}